import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, P } from "../../../../../AbstractElements";
import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount } from "../../../../../Constants/Constants";
import { LoginFormProp } from "../../../../../Types/OthersType";
import CommonLogo from "./CommonLogo";
import SocialLinks from "./SocialLinks";

const LoginForm: React.FC<LoginFormProp> = ({ logoClass }) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggle = () => setPasswordVisible(!isPasswordVisible);
  const [formData, setFormData] = useState({ email: "", password: "", checkbox1: false });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormData({ email: "", password: "", checkbox1: false });
  };
  return (
    <div>
      <div>
        <CommonLogo logoClass={logoClass} />
      </div>
      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit}>
          <H4>{SignInAccount}</H4>
          <P>{"Enter your email & password to login"}</P>
          <FormGroup>
            <Col><Label>{EmailAddress}</Label></Col>
            <Input type="email" required placeholder="Test@gmail.com" id="email" value={formData.email} onChange={handleInputChange} />
          </FormGroup>
          <FormGroup>
            <Col><Label>{Password}</Label></Col>
            <div className="form-input position-relative">
              <Input type={isPasswordVisible ? "text" : "password"} name="login[password]" autoComplete="off" required placeholder="*********" id="password" value={formData.password} onChange={handleInputChange} />
              <div className="show-hide" onClick={toggle}>
                <span className={!isPasswordVisible ? "show" : ""}></span>
              </div>
            </div>
          </FormGroup>
          <div className="mb-0 form-group">
            <div className="checkbox p-0">
              <Input id="checkbox1" type="checkbox" checked={formData.checkbox1} onChange={handleInputChange} />
              <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
            </div>
            <Link className="link" to={`${process.env.PUBLIC_URL}/auth/forget-password`}>{ForgotPassword}</Link>
            <div className="text-end mt-3">
              <Btn color="primary" block className="w-100">{SignIn}</Btn>
            </div>
          </div>
          <SocialLinks />
        </Form>
      </div>
    </div>
  );
};
export default LoginForm;
